module.exports = __webpack_public_path__ + "static/media/mind-top-right.0fba3aba.svg";